import { PaymentStatusPlain } from './layouts/Plain';
import { PaymentStatusStripe } from './layouts/Stripe';
import * as Styled from './styles';

type PaymentStatusProps = {
  handleSetSuccessStep?: () => void;
  proceedWithoutStripe?: boolean;
  setSuccessWithoutChecks?: boolean;
  nftId?: number;
  isParticipatingInRaffle?: boolean;
};

export const PaymentStatus = ({
  handleSetSuccessStep,
  proceedWithoutStripe,
  setSuccessWithoutChecks,
  nftId,
  isParticipatingInRaffle
}: PaymentStatusProps) => {
  return (
    <Styled.PaymentPending>
      {proceedWithoutStripe ? (
        <PaymentStatusPlain
          handleSetSuccessStep={handleSetSuccessStep}
          setSuccessWithoutChecks={setSuccessWithoutChecks}
          nftId={nftId}
          isParticipatingInRaffle={isParticipatingInRaffle}
        />
      ) : (
        <PaymentStatusStripe handleSetSuccessStep={handleSetSuccessStep} />
      )}
    </Styled.PaymentPending>
  );
};
